import { Controller } from "stimulus"
import Sortable from "sortablejs"
import Rails from "@rails/ujs"
import t from "../i18n"

export default class extends Controller {
  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 160,
      draggable: ".project-kanban-editor-column",
      handle: ".project-kanban-editor-column__drag",
      ghostClass: "project-kanban-editor-column--dragging",
      onEnd: this.end.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) this.sortable.destroy()
  }

  end(event) {
    const url = event.item.dataset.moveUrl
    if (!url) return

    const data = new FormData()
    data.append("position", event.newIndex)

    Rails.ajax({
      url: url,
      type: "PATCH",
      data: data,
      error: () => {
        this.revertMove(event)
        alert(t("kanban.order_failed", {}, "Die Spaltenreihenfolge konnte nicht gespeichert werden."))
      }
    })
  }

  revertMove(event) {
    const referenceNode = event.from.children[event.oldIndex] || null
    event.from.insertBefore(event.item, referenceNode)
  }
}
